import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { BaseErrorResponse } from 'api/api.config';

export const isValidationError = (error: unknown): error is string => {
  return typeof error === 'string' && error.startsWith('err.');
};

export function createGenericTransformVerifyErrorResponse<
  T extends BaseErrorResponse,
>(isValidResponseCallback: (errorResponse: unknown) => errorResponse is T) {
  return (errorResponse: FetchBaseQueryError) => {
    const errorResponseData = errorResponse.data;
    const is422Error = errorResponse.status === 422;

    if (!isValidResponseCallback(errorResponseData) || !is422Error) {
      return "Invalid error response. Couldn't parse error response data";
    }

    const apiErrorMessage = errorResponseData.error.errorInfos?.generic[0];

    if (apiErrorMessage && isValidationError(apiErrorMessage))
      return {
        errorMessage: 'verifyService.' + apiErrorMessage,
      };

    return "Invalid error response. Couldn't extract error message from error response data";
  };
}
